/**
 * Tính chất (1: HHDV; 2: khuyến mại; 3: chiết khẩu; 4: ghi chú/diễn giải)
 * NHANH3 28.09.2022
 */
export default {
  Product: 1,
  Promotion: 2,
  Extract: 3,
  Explain: 4,
};
